export const frontmatter = {
    "draft": false,
    "title": "Channels",
    "sidebar_group": "reference",
    "sidebar_label": "Channels",
    "sidebar_order": 4
}

export const toc = []